import React, { useState, useEffect } from "react";
import "./index.scss";
import FormGenerator from "../../core/form-generator";
import { getUserFormConfig } from "./config";
import { Box, Grid, FormControlLabel, styled, Switch } from "@mui/material";
import {
  convertCamelCaseToDisplayText,
  getFileNameFromUrl,
  handleFormValidation,
  PAGE_LIMIT,
} from "../../utils";
import SiFileUpload from "../../core/file-uploader";
import CustomButtonComponent from "../../core/custom-button";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { toast } from "react-toastify";

import InputWithAction from "../../pages/admin/literature/service-information";
import SiTextField from "../../core/si-textfield";
const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  marginRight: "0.5rem",
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "primary",
        opacity: 1,
        border: 0,
        ...theme.applyStyles("dark", {
          backgroundColor: "primary",
        }),
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.grey[100],
      ...theme.applyStyles("dark", {
        color: theme.palette.grey[600],
      }),
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
      ...theme.applyStyles("dark", {
        opacity: 0.3,
      }),
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#E9E9EA",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
    ...theme.applyStyles("dark", {
      backgroundColor: "#39393D",
    }),
  },
}));
const CreateUser = ({ setIsCreate, loadData, editData }) => {
  const [formData, setFormData] = useState({
    limits: {
      serviceEngineer: false,
      floatEngineManager: false,
      approver: false,
      admin: false,

      qualityCreator: false,
      qualityApprover: false,
      qualityAdmin: false,
    },
  });
  const [errors, setErrors] = useState({});
  const [phoneNumber, setPhoneNumber] = useState("");
  const resetHandler = () => {
    setFormData({
      limits: {
        serviceEngineer: false,
        floatEngineManager: false,
        approver: false,
        admin: false,

        qualityCreator: false,
        qualityApprover: false,
        qualityAdmin: false,
      },
    });
    setPhoneNumber("");
    loadData({ page: 1, sortBy: "-createdAt", limit: PAGE_LIMIT });
  };
  const validateLimits = () => {
    const hasAtLeastOne = Object.values(formData.limits).some((value) => value);
    if (!hasAtLeastOne) {
      setErrors((prev) => ({
        ...prev,
        limits: "At least one role must be selected",
      }));
      return false;
    }
    setErrors((prev) => ({ ...prev, limits: null }));
    return true;
  };
  const updateLimitsHandler = (id, limits) => {
    const payload = {
      ...limits,
    };
    if (phoneNumber) {
      payload["phoneNumber"] = phoneNumber;
    }
    invokeApi(HTTP_METHODS.PUT, `${HOSTNAME}${REST_URLS.LIMITS}/${id}`, payload)
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
          return;
        } else {
          toast.success("Updated Successfully");
          setIsCreate(false);
          resetHandler();
        }
      })
      .catch((err) => console.error(err));
  };
  const submitHandler = () => {
    const isValid = handleFormValidation(
      getUserFormConfig(editData),
      setErrors,
      formData
    );
    if (isValid) {
      if (!validateLimits()) {
        toast.error("Please select at least one role before submitting.");
        return;
      }
      if (
        formData?.limits?.serviceEngineer &&
        phoneNumber?.trim().length !== 10
      ) {
        toast.error("Valid Phone Number is required for Service Engineer");
        return;
      }
      const payload = {
        ...formData,
      };
      delete payload.limits;
      if (editData?.id) {
        invokeApi(
          HTTP_METHODS.PUT,
          `${HOSTNAME}${REST_URLS.USERS}/${editData.id}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              updateLimitsHandler(
                res.limits?.id || res.limits,
                formData.limits
              );
            }
          })
          .catch((err) => console.error(err));
      } else {
        invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${REST_URLS.USERS}`, payload)
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              updateLimitsHandler(res.limits, formData.limits);
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };
  useEffect(() => {
    if (editData?.id) {
      const { name, email, limits, phoneNumber } = editData;
      setFormData((prevVal) => ({
        ...prevVal,
        name,
        email,

        limits: {
          serviceEngineer: limits.serviceEngineer,
          floatEngineManager: limits.floatEngineManager,
          approver: limits.approver,
          admin: limits.admin,
          qualityCreator: limits.qualityCreator,
          qualityApprover: limits.qualityApprover,
          qualityAdmin: limits.qualityAdmin,
        },
      }));
      if (phoneNumber) {
        setPhoneNumber(phoneNumber);
      }
    }
  }, [editData]);
  const handleSwitchChange = (key) => (event) => {
    setFormData((prev) => ({
      ...prev,
      limits: {
        ...prev.limits,
        [key]: event.target.checked,
      },
    }));
  };

  return (
    <div>
      <div className="form-con" style={{ width: "100%" }}>
        <FormGenerator
          config={getUserFormConfig(editData)}
          formData={formData}
          setFormData={setFormData}
          errors={errors}
          setErrors={setErrors}
        />
        {formData?.limits?.serviceEngineer && (
          <Grid container>
            <Grid item md={4} sx={{ pr: 3 }}>
              <p>Phone Number*</p>
              <SiTextField
                placeholder="Phone Number"
                type="number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </Grid>
          </Grid>
        )}

        <p>User Roles*</p>
        <Grid container spacing={2} sx={{ ml: 0.5 }} md={11}>
          {Object.keys(formData.limits).map((key) => (
            <Grid item xs={12} sm={6} md={2} key={key}>
              <FormControlLabel
                control={
                  <IOSSwitch
                    checked={formData.limits[key]}
                    onChange={handleSwitchChange(key)}
                    color="primary"
                  />
                }
                label={
                  key === "approver"
                    ? "Admin Approver"
                    : convertCamelCaseToDisplayText(key)
                }
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "14px",
                  },
                }}
              />
            </Grid>
          ))}
        </Grid>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 5,
            mb: 2,
            gridGap: "1rem",
            alignItems: "center",
          }}
        >
          <CustomButtonComponent
            variant="contained"
            color="primary"
            sx={{ width: "150px" }}
            onClick={submitHandler}
          >
            Submit
          </CustomButtonComponent>
        </Box>
      </div>
    </div>
  );
};

export default CreateUser;
